import React, { useContext, useEffect, useRef } from 'react';
import { v4 as uuid } from 'uuid';
import fileSize from 'filesize';
import {
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { MdDeleteForever, MdFileDownload, MdVisibility } from 'react-icons/md';
import { Button, FileInfo, LabelFileInput, FileInput, Title } from './styled';
import { DefaultCollectContext } from '../../../..';

export const OtherFiles = () => {
  const inputFileRef = useRef(null);

  const maxXS = useMediaQuery('(max-width:480px)');
  const maxSM = useMediaQuery('(max-width:768px)');

  const {
    otherFiles,
    setOtherFiles,
    useForceUpdate,
    openRemoveFileModal,
    documentType: documentTypeContext
  } = useContext(DefaultCollectContext);

  const forceUpdate = useForceUpdate();

  const handleAddOtherFiles = (event) => {
    const { files } = event.target;
    const newOtherFiles = [...otherFiles];

    Array.from(files).forEach((file) => {
      newOtherFiles.push({
        id: uuid(),
        file,
        name: file.name,
        size: file.size,
        readableSize: fileSize(file.size),
        documentType: '',
        hasDocumentTypeError: false
      });
    });

    setOtherFiles(newOtherFiles);

    inputFileRef.current.value = '';

    forceUpdate();
  };

  const handleOpenOtherFile = (otherFile) => {
    const file = new Blob([otherFile], { type: otherFile.type });
    const fileURL = URL.createObjectURL(file);
    const pdfWindow = window.open();
    pdfWindow.location.href = fileURL;
  };

  const handleDownloadOtherFile = (otherFile) => {
    const file = new Blob([otherFile], { type: otherFile.type });
    const fileURL = URL.createObjectURL(file);
    const link = document.createElement('a');
    link.href = fileURL;
    link.setAttribute('download', otherFile.name);

    document.body.appendChild(link);

    link.click();

    link.parentNode.removeChild(link);
  };

  const handleSetDocumentType = (event, id) => {
    const { value: documentType } = event.target;

    const indexFile = otherFiles.findIndex((file) => file.id === id);

    const newOtherFiles = [...otherFiles];

    newOtherFiles[indexFile].documentType = documentType;
    newOtherFiles[indexFile].hasDocumentTypeError = false;

    setOtherFiles(newOtherFiles);
  };

  useEffect(() => {
    if (documentTypeContext !== 'declaration') {
      const newOtherFiles = [...otherFiles];

      newOtherFiles.forEach((otherFile, index) => {
        if (otherFile.documentType === '3') {
          newOtherFiles[index].documentType = '';
        }
      });

      setOtherFiles(newOtherFiles);
    }
  }, [documentTypeContext]);

  return (
    <Stack
      spacing={2}
      style={{ width: '100%', alignItems: 'flex-start' }}
      divider={<Divider orientation="horizontal" flexItem />}
    >
      <Stack>
        <Title style={{ marginTop: '20px', marginBottom: '20px' }}>
          Documentos Adicionais:
        </Title>
        <LabelFileInput htmlFor="otherFiles">
          ANEXAR OUTROS DOCUMENTOS
        </LabelFileInput>
        <FileInput
          data-testid="addOtherFilesInput"
          ref={inputFileRef}
          id="otherFiles"
          type="file"
          multiple
          onChange={handleAddOtherFiles}
        />
      </Stack>

      {otherFiles.length > 0 && (
        <Stack
          gap={1.5}
          style={{ width: '100%' }}
          divider={<Divider orientation="horizontal" flexItem />}
        >
          {otherFiles.map(
            ({
              id,
              file,
              name,
              readableSize,
              documentType,
              hasDocumentTypeError
            }) => (
              <Stack
                key={id}
                style={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: maxSM ? 'column' : 'row',
                  alignItems: maxSM ? 'flex-start' : 'center',
                  justifyContent: 'space-between'
                }}
              >
                <FileInfo>
                  <strong
                    style={{
                      width: maxXS && 312,
                      textOverflow: maxXS && 'ellipsis',
                      overflow: maxXS && 'hidden',
                      whiteSpace: maxXS && 'nowrap'
                    }}
                  >
                    {name}
                  </strong>
                  <span>{readableSize}</span>
                </FileInfo>

                <Stack direction="row" gap={1}>
                  <Button
                    type="button"
                    data-testid="openOtherFileButton"
                    onClick={() => handleOpenOtherFile(file)}
                  >
                    <MdVisibility size={20} />
                  </Button>

                  <Button
                    type="button"
                    data-testid="downloadOtherFileButton"
                    onClick={() => handleDownloadOtherFile(file)}
                  >
                    <MdFileDownload size={20} />
                  </Button>

                  <Button
                    type="button"
                    data-testid="removeOtherFileButton"
                    onClick={() => openRemoveFileModal(id)}
                  >
                    <MdDeleteForever size={20} />
                  </Button>

                  <FormControl>
                    <InputLabel size="small">Tipo de Documento: *</InputLabel>
                    <Select
                      label="Tipo de Documento: *"
                      size="small"
                      value={documentType}
                      onChange={(event) => {
                        handleSetDocumentType(event, id);
                      }}
                      style={{ width: 204 }}
                      error={hasDocumentTypeError}
                    >
                      <MenuItem value="" disabled />
                      <MenuItem value="1">Carta de Autorização</MenuItem>
                      <MenuItem value="2">Carta de Avaria</MenuItem>
                      <MenuItem
                        value="3"
                        disabled={documentTypeContext !== 'declaration'}
                      >
                        Declaração
                      </MenuItem>
                      <MenuItem value="4">FISPQ</MenuItem>
                    </Select>
                  </FormControl>
                </Stack>
              </Stack>
            )
          )}
        </Stack>
      )}
    </Stack>
  );
};
